import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";

// App
import { FormikField } from "../../core/components/formik";
import { validateRequired } from "../../../utilities/validators";
import { ButtonChangePassword, ButtonChangeTotpSecretKey } from "../../core/components/shared/Buttons";
import FieldLabel from "../../core/components/formik/FieldLabel";
import FormGroup from "reactstrap/es/FormGroup";
import InputGroup from "reactstrap/es/InputGroup";

const FieldsetAPI = (props) => {
  const { passwordRequired, values } = props;
  const { t } = useTranslation();

  // Stavy zobrazeni tlacitek
  const [showButtonPasswordRead, setShowButtonPasswordRead] = useState(true !== passwordRequired ? (values?.apiPasswordReadExists ?? false) : false);
  const [showButtonPasswordWrite, setShowButtonPasswordWrite] = useState(true !== passwordRequired ? (values?.apiPasswordWriteExists ?? false) : false);
  const [showButtonTotpSecretKey, setShowButtonTotpSecretKey] = useState(true !== passwordRequired ? (values?.apiTotpSecretKeyExists ?? false) : false);

  // Handlery pro zmenu stavu tlacitek
  const handleToggleButtonPasswordRead = () => {
    setShowButtonPasswordRead(false);
  }
  const handleToggleButtonPasswordWrite = () => {
    setShowButtonPasswordWrite(false);
  }
  const handleToggleSecretKey = () => {
    setShowButtonTotpSecretKey(false);
  }

  return (
    <Fragment>
      <FormikField label={t("title.apiUri")} name="apiUri" required={true} type="url" validate={validateRequired} />
      <FormikField
        label={t("title.apiUsernameRead")}
        name="apiUsernameRead"
        required={true}
        validate={validateRequired}
      />
      {showButtonPasswordRead ? (
        <FormGroup>
          <FieldLabel label={t("title.apiPasswordRead")} required={false} />
          <InputGroup>
            <ButtonChangePassword onClick={handleToggleButtonPasswordRead}  size="md" text={t("action.changePasswordRead")} />
          </InputGroup>
        </FormGroup>
      ) : (
      <FormikField
        label={t("title.apiPasswordRead")}
        name="apiPasswordRead"
        required={passwordRequired}
        type="password"
        validate={passwordRequired ? validateRequired : undefined}
      />
      )}
      <FormikField
        label={t("title.apiUsernameWrite")}
        name="apiUsernameWrite"
        required={true}
        validate={validateRequired}
      />
      {showButtonPasswordWrite ? (
        <FormGroup>
          <FieldLabel label={t("title.apiPasswordWrite")} required={false} />
          <InputGroup>
            <ButtonChangePassword onClick={handleToggleButtonPasswordWrite}  size="md" text={t("action.changePasswordWrite")} />
          </InputGroup>
        </FormGroup>
      ) : (
      <FormikField
        label={t("title.apiPasswordWrite")}
        name="apiPasswordWrite"
        required={passwordRequired}
        type="password"
        validate={passwordRequired ? validateRequired : undefined}
      />
      )}
      {showButtonTotpSecretKey ? (
        <FormGroup>
          <FieldLabel label={t("title.apiTotpSecretKey")} required={false} />
          <InputGroup>
          <ButtonChangeTotpSecretKey  onClick={handleToggleSecretKey}  size="md" text={t("action.changeTotpSecretKey")} />
          </InputGroup>
        </FormGroup>
      ) : (
        <FormikField label={t("title.apiTotpSecretKey")} name="apiTotpSecretKey" required={false}   />
      )}
    </Fragment>
  );
};

FieldsetAPI.propTypes = {
  passwordRequired: PropTypes.bool.isRequired,
  values: {
    apiPasswordReadExists: PropTypes.string,
    apiPasswordWriteExists: PropTypes.string,
    apiTotpSecretKeyExists: PropTypes.string
  },
};

export default FieldsetAPI;
